<div [class]="type()">
  @if (type() !== null && type() !== undefined) {
    <div class="icon me-3">
      @switch (type()) {
        @case ('info') {
          <fa-icon size="lg" class="text-light-blue" [icon]="faInfoCircle"></fa-icon>
        }
        @case ('warning') {
          <fa-icon size="lg" class="text-yellow" [icon]="faExclamationTriangle"></fa-icon>
        }
        @case ('alert') {
          <fa-icon size="lg" class="text-red" [icon]="faExclamationCircle"></fa-icon>
        }
        @case ('success') {
          <fa-icon size="lg" class="text-green" [icon]="faCheckCircle"></fa-icon>
        }
        @case ('legal') {
          <fa-icon size="lg" class="text-legal" [icon]="faInfoCircle"></fa-icon>
        }
        @case ('outdated') {
          <fa-icon size="lg" class="text-outdated" [icon]="faInfoCircle"></fa-icon>
        }
      }
    </div>
  }
  <div class="content"><ng-content></ng-content></div>
</div>
